<template>
  <view class="flights-container">
    <QueryCard ref="QueryCard"/>
    <Diamonds wx:if="{{diamondsConf.length}}" class="diamonds" diamondsConf="{{diamondsConf}}" bind:pageGoTo="pageGoTo" />
    <FlightsCouponBanner wx:if="{{gotCoupons}}" class="coupon-area"/>
    <SpecialTicket
      mixinShowProp="{{mixinShowProp}}"
      bind:specialTicketTap="onSpecialTicketTap"
    />
    <Service notices="{{notices}}" />
    <Slogan
      sloganIcon="https://ut-static.udache.com/webx/sfc/Omh3erNxbVue_HKBMUB5l.png"
    />
    <Privacy
      wx:if="{{privacyVisible}}"
      list="{{privacyList}}"
      bind:privacyVerify="onPrivacyVerify"
      scene="didijipiao"
      caller="flights_home_to_tc"
    />
  </view>
  <FlightsFallingPopup wx:if="{{gotCoupons}}" fallingConf="{{flightsFallingConf}}" />
</template>

<script>
  import { createComponent } from '@mpxjs/core'
  import onShowHandleMixins from '@/mixins/homeTabOnShowHandleMixins'
  import store from '@/store'
  import { trackEvent } from '@/common/track'
  import { sendEvent,watchEvent } from '@/utils'
  import { flightsFallingConf } from '@/config/flights-falling-popup'
  import { isALIMini } from '@/common/constant'
  import { FLIGHTS_TYPES } from '@/common/enum'
  import { gotoPurchaseInformationPage } from '@/common/pageJump'
  import { is } from '@didi/spring-base'

  createComponent({
    mixins: [onShowHandleMixins],
    created() {
      // if (this.gotCoupons) {
      //   sendEvent('updateFlightsFallingCoupon')
      //   console.log('更新天降');
      // }
    },
    data: {
      flightsFallingConf,
      gotCoupons: false,
    },
    computed: {
      ...store.mapState({
        privacyList:'flights.privacyList',
        privacyVisible:'flights.privacyVisible',
      }),
      notices() {
        return [{
          title: '服务协议及个人信息处理规则',
          url: is('jhalipay') ? 'https://page.udache.com/driver-activity-biz/baichuan-policy-agreement/index.html?mode=2&bc_scene=flight_train&lang=zh-CN&bc_appid=121735' : 'https://page.udache.com/driver-activity-biz/baichuan-policy-agreement/index.html?mode=2&bc_scene=didijipiao&bc_appid=10000'
        }, {
          title: '证照信息',
          url: 'https://v.didi.cn/p/2j1M5qG'
        }]
      },
      contactPhone() {
        return '4006608012'
      },
      email() {
        return 'jipiaokefu@didiglobal.com'
      },
      diamondsConf() {
        const defaultConf = isALIMini ? [] : [
          {
            type: 'guidebook',
            text: '飞行指南',
            icon:
              'https://ut-static.udache.com/webx/sfc/2jdW8vKgyMfba7yWm8yG_.png',
          },
        ]
        return [
          ...defaultConf,
          {
            type: 'order',
            text: '我的订单',
            icon:
              'https://ut-static.udache.com/webx/sfc/gdI5JtzocGU3BMbRganUP_22.png',
          },
          {
            type: 'contactCustomerService',
            text: '联系客服',
            icon:
              'https://ut-static.udache.com/webx/sfc/WkQap-DxD5m-ewCKtemSO_33.png',
          }
        ]
      },
    },
    methods: {
      ...store.mapActions({
        getFlightsCityList: 'flights.getFlightsCityList',
        getQueryCardBtnText: 'flights.getQueryCardBtnText',
        checkPrivacyStatus:'flights.checkPrivacyStatus',
        jumpTcUrl:'flights.jumpTcUrl',
      }),
      ...store.mapMutations({
        updateFlightsQuery:'flights.updateFlightsQuery',
        onPrivacyVerify:'flights.onPrivacyVerify',
      }),
      onShowHandle() {
        this.getQueryCardBtnText()
        setTimeout(() => {
          trackEvent('yks_plane_home_sw', '迎客松-机票-首页-曝光', {
            type: this.$refs.QueryCard.tabChoosed === FLIGHTS_TYPES.ONE
              ? 'uniaxial'
              : 'biaxial'
          })
        })
        if(!this.gotCoupons) {
          this.gotCoupons = true
        }else {
          sendEvent('updateFlightsCoupon')
          sendEvent('updateFlightsFallingCoupon')
        }
        this.updateFlightsQuery()
      },
      async pageGoTo({ detail }) {
        const { type } = detail
        const authWhiteList = ['contactCustomerService']
        const trackDataMap = {
          contactCustomerService: {
            event: 'userteam_plane_home_service_ck',
            name: 'UT-飞机票-首页-联系客服按钮-点击',
          },
          order: {
            event: 'userteam_plane_home_order_ck',
            name: 'UT-飞机票-首页-我的订单按钮-点击',
          },
          guidebook: {
            event: 'userteam_plane_home_guide_ck',
            name: 'UT-飞机票-首页-飞行指南按钮-点击',
          }
        }
        trackEvent(trackDataMap[type].event, trackDataMap[type].name)
        if(!authWhiteList.includes(type)) {
          await this.checkPrivacyStatus()
        }
        switch (type) {
          case 'contactCustomerService':
            const source = is('passenger')
              ? 'app_ddcx_ummhc_im'
              : is('weixin')
              ? 'xcx_ddcx_egeda_im'
              : is('alipay')
              ? 'zfbxcx_ddcx_iemeq_im'
              : ''
            gotoPurchaseInformationPage({
              type: 'flights',
              source
            })
            break
          case 'guidebook':
          case 'order':
            this.jumpTcUrl({
              type
            })
            break
        }
      },
      async onSpecialTicketTap({ detail }) {
        await this.checkPrivacyStatus()
        this.jumpTcUrl({
          type: detail.type,
          sourceData: detail.item,
        })
      },
    }
  })
</script>

<style lang="stylus" scoped>
  .flights-container
    box-sizing border-box
    height auto
    padding 0 10px
    .diamonds
      margin 8px auto
    .coupon-area
      margin-bottom 8px
</style>

<script  name="json">
  module.exports = {
    usingComponents: {
      'Diamonds': '../diamonds',
      'SpecialTicket': './special-ticket.mpx',
      'QueryCard': './query-card-flights.mpx',
      'Slogan': '@/components/slogan',
      'Privacy': '@/pages/train-detail/components/privacy',
      'FlightsCouponBanner': '@/components/flights-coupon/coupon-banner',
      'FlightsFallingPopup': '@/components/flights-coupon/falling-popup',
      'Service': '@/components/home-service',
    }
  }
</script>